export const state = () => ({})

export const getters = {}

export const mutations = {}

export const actions = {
  async fetchCep({ commit }, cep) {
    const data = await this.$axios.$get(`https://viacep.com.br/ws/${cep}/json`)
    return data
  },

  async fetchStateBrazil({ commit }) {
    const data = await this.$axios.$get(
      'https://servicodados.ibge.gov.br/api/v1/localidades/estados/'
    )
    return data
  },

  async fetchCityBrazil({ commit }, city) {
    const data = await this.$axios.$get(
      `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${city}/municipios/`
    )
    return data
  },

  async fetchAllCities({ commit }, city) {
    const data = await this.$axios.$get(
      `https://servicodados.ibge.gov.br/api/v1/localidades/municipios/${city}`
    )
    return data
  },
  // configurar server lambda para verificar token valido ou nao
  async verifyGoogleReCaptcha({ commit }, response) {
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
    }
    const data = await this.$axios.$post(
      `https://www.google.com/recaptcha/api/siteverify`,
      `secret=${process.env.RECAPTCHA_SECRET_KEY}&response=${response}`,
      { headers }
    )
    return data
  },
  async sendMessageSlack({ commit }, message) {
    const urlLambda =
      'https://hafcsud2z8.execute-api.us-east-1.amazonaws.com/send-message-slack'
    const data = await this.$axios.$post(urlLambda, message)
    return data
  },
}
